import {
  getArticleCategoriesData,
  getArticleCategoriesPageQueries,
} from '../_service/hub'
import { getArticleData } from '../_components/ArticlePageTemplate/_service'
import ArticlePageTemplate from '../_components/ArticlePageTemplate'
import HubPageTemplate from '../_components/HubPageTemplate'
import { getLocaleList } from '../../_helper/getLocaleList'

import type { InferGetServerSidePropsType, NextPage } from 'next'

import { pFallback } from '@/helpers/promises'
import { getServerSideData } from '@/helpers/server-data'
import { NotFoundError } from '@/helpers/server-data/errors'
import { ALL_LANGUAGES } from '@/components/LanguageSwitcher/data'

const Page: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (
  props,
) => {
  const { type, data, url, locales } = props

  switch (type) {
    case 'article':
      return <ArticlePageTemplate pageData={data} locales={locales} />
    case 'hub':
      return <HubPageTemplate pageData={data} />
    default:
      throw new Error(`${url} is not found`)
  }
}
export default Page

// eslint-disable-next-line react-refresh/only-export-components
export const getServerSideProps = getServerSideData({
  cacheControl: true,
})(async (_, ctx) => {
  const slug = ctx.params?.params as string[]
  const params = getArticleCategoriesPageQueries(slug)
  const url = params[0] as string
  const locale = ctx.locale || 'en'
  const langObj = ALL_LANGUAGES.find((e) => e.abbr === locale) || null
  const currentLocale = langObj && locale !== 'en' ? langObj.lang : 'en'

  const results = await Promise.all([
    pFallback(async () => {
      const data = await getArticleData(url, currentLocale, locale)
      const localeList = await getLocaleList(url, 'tad_articles')
      const locales = localeList?.map((item) => item.attributes.locale) ?? []
      if (data) {
        return {
          type: 'article',
          data,
          locales,
          url,
        } as const
      }
    })({
      defaultValue: null,
    }),
    pFallback(async () => {
      const data = await getArticleCategoriesData('tad', params, {
        locale: currentLocale,
      })
      if (data) {
        return {
          type: 'hub',
          data,
          locales: [],
          url,
        } as const
      }
    })({
      defaultValue: null,
    }),
  ])

  if (results.every((item) => !item?.data)) {
    // handleCMSLog(
    //   host,
    //   Array.isArray(slug) ? `${prefixUrl}/${slug?.join('/')}` : prefixUrl,
    //   results,
    // )
    throw new NotFoundError(`url is not found`)
  }

  const result = results.find((item) => !!item?.data)!
  return result
})
